import { getString } from "../common/common";

export const SEARCH = "SEARCH";
export const FOOTER_COMP_INFO = "FOOTER_COMP_INFO";
export const TRIP_CODE = "TRIP_CODE";
export const DEPARTURE_TIME = "DEPARTURE_TIME";
export const PICKUPS = "PICKUPS";
export const DROPOFFS = "DROPOFFS";
export const OTHERS = "OTHERS";
export const POLICIES = "POLICIES";
export const BACK_TO_RESULT = "BACK_TO_RESULT";
export const RESET = "RESET";
export const I_AGREE = "I_AGREE";
export const TERMS_AND_CONDITIONS = "TERMS_AND_CONDITIONS";
export const AND = "AND";
export const PRIVACY_POLICY = "PRIVACY_POLICY";
export const YOUR_IP_ADDRESS = "YOUR_IP_ADDRESS";
export const YOU_AGREE = "YOU_AGREE";
export const CONFIRM_AGREE = "CONFIRM_AGREE";
export const CONFIRM_DONT_AGREE = "CONFIRM_DONT_AGREE";
export const ENTER_COUNTRY_CODE = "ENTER_COUNTRY_CODE";
export const VALID_EMAIL_REQ = "VALID_EMAIL_REQ";
export const VAL_PHN_NO = "VLD_PHN_NO";
export const PLZ_ENT_PWD = "PLZ_ENT_PWD";
export const ENTER_VALID_MOBILE = "ENTER_VALID_MOBILE";

export const BUS_PNR = "Bus_PNR";
export const ENQ = "Enquiry";
export const OB_REF = "OB_Reference";
export const MOBILE_BASED = "Mobile_Based";
export const EMAIL_BASED = "Email_ID_Based";
export const MOBILE_EMAIL_BASED = "Mobile_Email_Based";
export const BUS_SER = "Bus_Service";
export const BUS_TICKET_BOOKING = "Bus_Ticket_Booking";
export const TOUR_PACKAGE_BOOKING = "Tour_Package_Booking";
export const BUS_TRUCK_HIRE = "Bus_Truck_Hire";
export const CARGO_BOOKING = "Cargo_Booking";
export const EDIT_YOUR_PROFILE = "Edit_Your_Profile";
export const DELETE_YOUR_PROFILE = "Delete_Your_Profile";
export const LOGOUT = "LOGOUT";
export const SORTED_BY_IN_DESCENDING_ORDER = "SORTED_BY_IN_DESCENDING_ORDER";
export const THERE_ARE_NO = "THERE_ARE_NO";
export const BOOKINGS_FOR_THIS_MOBILE_NUMBER =
  "BOOKINGS_FOR_THIS_MOBILE_NUMBER";
export const BOOKING_DATE = "BOOKING_DATE";
export const JOURNEY_DATE = "JOURNEY_DATE";
export const VALID_PNR_NUMBER = "VALID_PNR_NUMBER";
export const PNR_NUMBER = "PNR_NUMBER";
export const MOBILE_NUMBER = "MOBILE_NUMBER";
export const GO_BACK_HOME = "GO_BACK_HOME";
export const YES = "YES";
export const NO = "NO";
export const OK = "OK";
export const GOBACK = "GOBACK";
export const GUEST_USER_NOT_LOGIN = "GUEST_USER_NOT_LOGIN";
export const ENTER_TXN_PASSWORD = "ENTER_TXN_PASSWORD";
export const TXN_PWD = "TXN_PWD";
export const IHAVE_GSTIN_NO = "IHAVE_GSTIN_NO";
export const COUNTRY_CODE = "COUNTRY_CODE";
export const SELECT_COUNTRY_CODE = "SELECT_COUNTRY_CODE";
export const SEARCH_NATIONALITY = "SEARCH_NATIONALITY";
export const SEARCH_COUNTRY_CODE = "SEARCH_COUNTRY_CODE";
export const ENTER_VALID_GSTIN = "ENTER_VALID_GSTIN";
export const ENTER_LEGAL_BUSINESS_NAME = "ENTER_LEGAL_BUSINESS_NAME";
export const GSTIN = "GSTIN";
export const LEGAL_BUSINESS_NAME = "LEGAL_BUSINESS_NAME";
export const LOCKOTP_MSG = "LOCKOTP_MSG";
export const CONNECT_BUS_OPTION = "CONNECT_BUS_OPTION";

export const translations = {
  en: {
    [SEARCH]: "Search",
    [FOOTER_COMP_INFO]: `Karnataka State Road Transport Corporation - KSRTC | Powered by Amnex Infotechnologies
    Private Limited &amp; Mantis Technologies Private Limited`,
    [TRIP_CODE]: "TripCode",
    [DEPARTURE_TIME]: "Departure Time",
    [PICKUPS]: "Pickups",
    [DROPOFFS]: "Dropoffs",
    [OTHERS]: "Others",
    [POLICIES]: "Policies",
    [BACK_TO_RESULT]: "Back to results",
    [RESET]: "RESET",
    [I_AGREE]: "I agree to KSRTC",
    [TERMS_AND_CONDITIONS]: "Terms & Conditions",
    [AND]: "and",
    [PRIVACY_POLICY]: "Privacy Policy",
    [YOUR_IP_ADDRESS]: "Your IP Address:",
    [YOU_AGREE]: "You need to agree to KSRTC's",
    [CONFIRM_AGREE]: "AGREE",
    [CONFIRM_DONT_AGREE]: "DON’T AGREE",
    [ENTER_COUNTRY_CODE]: "Enter Country Code",
    [VALID_EMAIL_REQ]: "Valid Email Required",
    [VAL_PHN_NO]: "Valid Phone Number",
    [PLZ_ENT_PWD]: "Please Enter Password",
    [ENTER_VALID_MOBILE]: "Please enter Valid Mobile number",

    [BUS_PNR]: "Bus PNR",
    [ENQ]: "Enquiry",
    [OB_REF]: "OB Reference",
    [MOBILE_BASED]: "Mobile Based",
    [EMAIL_BASED]: "Email ID Based",
    [MOBILE_EMAIL_BASED]: "Mobile/Email ID Based",
    [BUS_SER]: "Bus Service",
    [BUS_TICKET_BOOKING]: "Bus Ticket Booking",
    [TOUR_PACKAGE_BOOKING]: "Tour Package Booking",
    [BUS_TRUCK_HIRE]: "Bus Truck Hire",
    [CARGO_BOOKING]: "Cargo Booking",
    [EDIT_YOUR_PROFILE]: "Edit Your Profile",
    [DELETE_YOUR_PROFILE]: "Delete Your Account",
    [LOGOUT]: "LOGOUT",
    [SORTED_BY_IN_DESCENDING_ORDER]: "Sorted in descending order by",
    [THERE_ARE_NO]: "There are no",
    [BOOKINGS_FOR_THIS_MOBILE_NUMBER]: "bookings for this mobile number",
    [BOOKING_DATE]: "Booking Date",
    [JOURNEY_DATE]: "Journey Date",
    [VALID_PNR_NUMBER]: "Valid PNR Number",
    [PNR_NUMBER]: "PNR Number",
    [MOBILE_NUMBER]: "Mobile Number",
    [GO_BACK_HOME]: "Go Back Home",
    [YES]: "Yes",
    [NO]: "No",
    [OK]: "OK",
    [GOBACK]: "GO BACK",
    [GUEST_USER_NOT_LOGIN]: "You’re a guest user & not logged in",
    [ENTER_TXN_PASSWORD]: "Please enter Txn. Password",
    [TXN_PWD]: "Txn. Password",
    [IHAVE_GSTIN_NO]: "I have GSTIN Number",
    [COUNTRY_CODE]: "Country Code",
    [SELECT_COUNTRY_CODE]: "Select Country Code",
    [SEARCH_NATIONALITY]: "Search Nationality",
    [SEARCH_COUNTRY_CODE]: "Search Country Code",
    [ENTER_VALID_GSTIN]: "Enter valid GSTIN",
    [ENTER_LEGAL_BUSINESS_NAME]: "Enter Legal Business Name",
    [GSTIN]: "GSTIN",
    [LEGAL_BUSINESS_NAME]: "Legal Business Name",
    [LOCKOTP_MSG]:"OTP validation service has been locked for next 30 minutes due to too many failed attempts.",
    [CONNECT_BUS_OPTION]:"Click Here for Connecting Bus Options",
  },
  kn: {
    [FOOTER_COMP_INFO]: `ಕರ್ನಾಟಕ ರಾಜ್ಯ ರಸ್ತೆ ಸಾರಿಗೆ ನಿಗಮ - KSRTC | ಆಮ್ನೆಕ್ಸ್ ಇನ್ಫೋ ಟೆಕ್ನಾಲಜೀಸ್ ಪ್ರೈವೇಟ್ ಲಿಮಿಟೆಡ್ &amp; ಮ್ಯಾಂಟಿಸ್
    ಟೆಕ್ನಾಲಜೀಸ್ ಪ್ರೈವೇಟ್ ಲಿಮಿಟೆಡ್ ನಿಂದ ನಡೆಸಲ್ಪಡುತ್ತಿದೆ`,
    [SEARCH]: "ಹುಡುಕಿ",
    [TRIP_CODE]: "ಟ್ರಿಪ್‌ಕೋಡ್",
    [DEPARTURE_TIME]: "ನಿರ್ಗಮನ ವೇಳೆ",
    [PICKUPS]: "ಪಿಕಪ್",
    [DROPOFFS]: "ಡ್ರಾಪ್ ಆಫ್",
    [OTHERS]: "ಇತರರು",
    [POLICIES]: "ನೀತಿಗಳು",
    [BACK_TO_RESULT]: "ಫಲಿತಾಂಶಗಳಿಗೆ ಹಿಂತಿರುಗಿ",
    [RESET]: "ರೀಸೆಟ್ ಮಾಡಿ",
    [I_AGREE]: "ಕ.ರಾ.ರ.ಸಾ.ನಿಗಮದ",
    [TERMS_AND_CONDITIONS]: "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ಒಪ್ಪಿಕೊಳ್ಳುತ್ತೇನೆ.",
    [AND]: "ಮತ್ತು",
    [PRIVACY_POLICY]: "ಗೌಪ್ಯತೆ ನೀತಿಯನ್ನು",
    [YOUR_IP_ADDRESS]: "ನಿಮ್ಮ IP ವಿಳಾಸ:",
    [YOU_AGREE]: "ನೀವು KSRTCಗೆ ಒಪ್ಪಿಗೆ ನೀಡಬೇಕು",
    [CONFIRM_AGREE]: "ಒಪ್ಪುತ್ತೇನೆ",
    [CONFIRM_DONT_AGREE]: "ಒಪ್ಪುವುದಿಲ್ಲ",
    [ENTER_COUNTRY_CODE]: "ದೇಶದ ಕೋಡ್ ಎಂಟರ್ ಮಾಡಿ",
    [VALID_EMAIL_REQ]: "ಸರಿಯಾದ ಇಮೇಲ್ ಬೇಕಿದೆ",
    [VAL_PHN_NO]: "ಮಾನ್ಯವಾದ ಫೋನ್ ನಂಬರ್",
    [PLZ_ENT_PWD]: "ದಯವಿಟ್ಟು ಗುಪ್ತಪದ ಎಂಟರ್ ಮಾಡಿ",
    [ENTER_VALID_MOBILE]: "ದಯವಿಟ್ಟು ಸರಿಯಾದ ಮೊಬೈಲ್ ನಂಬರ್ ಅನ್ನು ಎಂಟರ್ ಮಾಡಿ",

    [BUS_PNR]: "ಬಸ್ PNR",
    [ENQ]: "ವಿಚಾರಣೆ",
    [OB_REF]: "ಓಬಿ ಉಲ್ಲೇಖ ಸಂಖ್ಯೆ",
    [MOBILE_BASED]: "ಮೊಬೈಲ್ ಆಧಾರಿತ",
    [EMAIL_BASED]: "ಇಮೇಲ್ ಐಡಿ ಆಧಾರಿತ",
    [MOBILE_EMAIL_BASED]: "ಮೊಬೈಲ್/ಇಮೇಲ್ ಐಡಿ ಆಧಾರಿತ",
    [BUS_SER]: "ಬಸ್ ಸೇವೆ",
    [BUS_TICKET_BOOKING]: "ಬಸ್ ಟಿಕೆಟ್ ಬುಕಿಂಗ್",
    [TOUR_PACKAGE_BOOKING]: "ಟೂರ್  ಪ್ಯಾಕೇಜ್ ಬುಕಿಂಗ್",
    [BUS_TRUCK_HIRE]: "ಬಸ್ / ಟ್ರಕ್ ಬಾಡಿಗೆ",
    [CARGO_BOOKING]: "ಕಾರ್ಗೋ ಬುಕಿಂಗ್",
    [EDIT_YOUR_PROFILE]: "ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಎಡಿಟ್ ಮಾಡಿ",
    [DELETE_YOUR_PROFILE]: "ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಡಿಲೀಟ್ ಮಾಡಿ",
    [LOGOUT]: "ಹೊರ ಹೋಗು",
    [SORTED_BY_IN_DESCENDING_ORDER]: "ಇಳಿಕೆಯ ಕ್ರಮದಲ್ಲಿ ವಿಂಗಡಿಸಲಾಗಿದೆ",
    [THERE_ARE_NO]: "ಈ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಗೆ ಯಾವುದೇ ",
    [BOOKINGS_FOR_THIS_MOBILE_NUMBER]: "ಬುಕಿಂಗ್‌ಗಳಿಲ್ಲ",
    [BOOKING_DATE]: "ಬುಕಿಂಗ್ ದಿನಾಂಕ",
    [JOURNEY_DATE]: "ಪ್ರಯಾಣದ ದಿನಾಂಕ",
    [VALID_PNR_NUMBER]: "ಸರಿಯಾದ PNR ನಂಬರ್",
    [PNR_NUMBER]: "PNR ಸಂಖ್ಯೆ",
    [MOBILE_NUMBER]: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ.",
    [GO_BACK_HOME]: "ಹೋಂ ಗೆ ಹಿಂತಿರುಗಿ",
    [YES]: "ಹೌದು",
    [NO]: "ಇಲ್ಲ",
    [OK]: "ಸರಿ",
    [GOBACK]: "ಹಿಂದೆ ಹೋಗು",
    [GUEST_USER_NOT_LOGIN]:
      "ನೀವು ಅತಿಥಿ ಬಳಕೆದಾರರಾಗಿದ್ದೀರಿ ಮತ್ತು ಲಾಗ್ ಇನ್ ಆಗಿಲ್ಲ",
    [ENTER_TXN_PASSWORD]: "ದಯವಿಟ್ಟು Txn ಅನ್ನು ಎಂಟರ್ ಮಾಡಿ . ಪಾಸ್ ವರ್ಡ್",
    [TXN_PWD]: "Txn. ಪಾಸ್ ವರ್ಡ್",
    [IHAVE_GSTIN_NO]: "ನನ್ನ ಹತ್ತಿರ GSTIN ನಂಬರ್ ಇದೆ",
    [COUNTRY_CODE]: "ದೇಶದ ಕೋಡ್",
    [SELECT_COUNTRY_CODE]: "ದೇಶದ ಕೋಡ್ ಆಯ್ಕೆಮಾಡಿ",
    [SEARCH_NATIONALITY]: "ಹುಡುಕಿ ರಾಷ್ಟ್ರೀಯತೆ",
    [SEARCH_COUNTRY_CODE]: "ಹುಡುಕಿ ದೇಶದ ಕೋಡ್",
    [ENTER_VALID_GSTIN]: "ಸರಿಯಾದ GSTIN ಎಂಟರ್ ಮಾಡಿ",
    [ENTER_LEGAL_BUSINESS_NAME]: "ಕಾನೂನು ವ್ಯವಹಾರದ ಹೆಸರನ್ನು ಎಂಟರ್ ಮಾಡಿ",
    [GSTIN]: "GSTIN",
    [LEGAL_BUSINESS_NAME]: "ಕಾನೂನು ವ್ಯವಹಾರದ ಹೆಸರು",
    [LOCKOTP_MSG]:"OTP validation service has been locked for next 30 minutes due to too many failed attempts.",
    [CONNECT_BUS_OPTION]:"Click Here for Connecting Bus Options",
  },
};

export const tCommon = (key = "", selectedLang = false) => {
  return getString(key, translations, selectedLang);
};
